import { SERVICE_MENU_STATUS_NAME, ServiceMenuStatus } from "@/consts/const";
import i18n from "@/main";

/**
 * サービスメニューステータス名
 */
export const serviceMenuStatus = (status: ServiceMenuStatus): string => {
  return i18n.t(SERVICE_MENU_STATUS_NAME[status]);
};
